import { Box, ListItemButton } from "@mui/material";
import moment from "moment-timezone";
import React from "react";
import { Link } from "react-router-dom";
import TypographyEllipsis from "../../../common/components/data-display/TypographyEllipsis";
import UserDisplay from "../../../common/components/data-display/UserDisplay";

export default function TermsConditionsSummary({
  sx,
  item,
  onClick,
  ...props
}) {
  const { id, type, version, createdAt, createdBy } = item;
  let linkProps = {};
  if (!props.onClick) {
    linkProps = {
      LinkComponent: Link,
      to: `/app/business-admin/manage-terms-conditions/view/${id}`,
    };
  }

  return (
    <ListItemButton
      sx={{
        mb: 0.125,
        width: "100%",
        maxWidth: 600,
        textAlign: "start",
        ...sx,
      }}
      {...linkProps}
      data-testid={"terms-conditions-summary"}
      {...props}
    >
      {/* If onClick prop is provided, use a CardActionArea - else use a Box */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          p: 0.5,
          flexWrap: "nowrap",
        }}
        onClick={onClick}
      >
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Box
            sx={{
              ml: 1.5,
              flexGrow: 1,
              maxWidth: 220,
              textWrap: "wrap",
            }}
          >
            <TypographyEllipsis
              variant="body1"
              sx={{
                fontWeight: 800,
              }}
            >
              {type === "buyer" ? "Buyer" : "Supplier"} T&C - v{version}
            </TypographyEllipsis>
            <TypographyEllipsis variant="body2">
              {moment(createdAt).format("LLL")}
            </TypographyEllipsis>
          </Box>
        </Box>
        <UserDisplay user={createdBy} label="Edited By" />
      </Box>
    </ListItemButton>
  );
}
